 //add active class on size

document.addEventListener("DOMContentLoaded", function () {
    // Select all ULs with class "p-size"
    const sizeLists = document.querySelectorAll(".p-size");

    sizeLists.forEach(function (list) {
      const items = list.querySelectorAll("li");

      items.forEach(function (item) {
        item.addEventListener("click", function () {
          // Remove active only inside this UL
          items.forEach(function (li) {
            li.classList.remove("active");
          });

          // Add active to clicked li
          this.classList.add("active");
        });
      });
    });
  });

  
jQuery(document).ready(function ($) {

  $(".mobile-toggle").click(function () {
    $(".menu ul").addClass("active");
  });
  $(".mob-menu-close").click(function () {
    $(".menu ul").removeClass("active");
  });
});

// $('.best-seller-slide').owlCarousel({
//     loop: true,
//     margin: 20,
//     nav: true,
//     navText: [
//       '<span class="custom-prev"><img src="assets/images/left-arrow.svg"></span>', 
//       '<span class="custom-next"><img src="assets/images/right-arrow.svg"></span>'
//     ],
//     items: 4,
//     dots: false,
//     autoplay: true,
//     responsive: {
//         0: {
//             items: 1,
//             nav: false
//         },
//         576: {
//             items: 1,
//         },
//         1000: {
//             items: 3,
//         },
//         1200: {
//             items: 4,
//         }
//     }
// })

jQuery(window).on('load', function() {
    jQuery('.best-seller-slide').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        navText: [
            '<span class="custom-prev"><img src="https://cdn.shopify.com/s/files/1/1612/6139/files/left-arrow.svg?v=1758897411" alt="prev"></span>',
            '<span class="custom-next"><img src="https://cdn.shopify.com/s/files/1/1612/6139/files/right-arrow.svg?v=1758897360" alt="next"></span>'
        ],
        items: 4,
        dots: false,
        autoplay: false,
        responsive: {
            0: { items: 1, nav: false },
            576: { items: 1 },
            1000: { items: 3 },
            1200: { items: 4 }
        }
    });
});


$('.testi-slide').owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    items: 3,
    dots: false,
    autoplay: true,
    responsive: {
        0: {
            items: 1,
            nav: false
        },
        576: {
            items: 2,
        },
        1000: {
            items: 3,
        },
        1200: {
            items: 3,
        }
    }
})
// $(".file-input").on("change", function () {
//     let fileName = $(this).val().split("\\").pop(); // Get file name only
//     if (fileName) {
//         $(".file-name").text(fileName); // Show file name in div
//     } else {
//         $(".file-name").text(""); // Clear if no file selected
//     }
// });
jQuery(document).ready(function($) {
  var mainImage = $('#product-main-image');
  var thumbSlider = $('.thumb-slider');

  thumbSlider.owlCarousel({
    items: 4,
    margin: 30, 
    nav: false,
    dots: false,
    smartSpeed: 300,
    responsive: {
      0: {
        margin: 10,  
        items: 3
      },
      768: {
        margin: 10,
        items: 3
      },
      1024: {
        margin: 10, 
        items: 3
      }
    }
  });

  thumbSlider.on('click', '.owl-item', function() {
    var thumbImg = $(this).find('img');
    var largeImage = thumbImg.data('large') || thumbImg.attr('src');

    mainImage.attr('src', largeImage);

    thumbSlider.find('.owl-item').removeClass('active-thumb');
    $(this).addClass('active-thumb');

    var visibleItems = thumbSlider.find('.owl-item.active');
    var firstVisibleIndex = visibleItems.first().index();
    var lastVisibleIndex = visibleItems.last().index();
    var clickedIndex = $(this).index();

    if (clickedIndex === lastVisibleIndex) {
      thumbSlider.trigger('next.owl.carousel');
    } else if (clickedIndex === firstVisibleIndex) {
      thumbSlider.trigger('prev.owl.carousel');
    }
  });

  thumbSlider.find('.owl-item').eq(0).addClass('active-thumb');
});





// jQuery(document).on("click", ".quantity .plus", function () {
//     var $input = jQuery(this).siblings("input");
//     var currentVal = parseInt($input.val()) || 1;
//     $input.val(currentVal + 1).trigger('change');
// });

// jQuery(document).on("click", ".quantity .minus", function () {
//     var $input = jQuery(this).siblings("input");
//     var currentVal = parseInt($input.val()) || 1;
//     if (currentVal > 1) {
//         $input.val(currentVal - 1).trigger('change');
//     }
// });




$(function() {
    const $slider = $(".slider");
    let isDown = false;
    let startX, scrollLeft;

    $slider.on("mousedown", function(e) {
      isDown = true;
      $slider.addClass("active");
      startX = e.pageX - $slider.offset().left;
      scrollLeft = $slider.scrollLeft();
      $slider.css("cursor", "grabbing");
    });

    $(document).on("mouseup", function() {
      isDown = false;
      $slider.removeClass("active");
      $slider.css("cursor", "grab");
    });

    $(document).on("mousemove", function(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - $slider.offset().left;
      const walk = (x - startX) * 2; // scroll speed multiplier
      $slider.scrollLeft(scrollLeft - walk);
    });
  });


 jQuery(window).on('load', function () {
  jQuery('#page-loader').fadeOut(500, function() {
    jQuery(this).remove();
  });
});